"use client";

import { Toaster as Sonner, toast as sonnerToast } from "sonner";

import "@config/tailwind-config/styles.css";

import { cn } from "../../lib/utils";
import { StickerBadge } from "./badge";

type ToasterProps = React.ComponentProps<typeof Sonner>;

function Toaster(props: ToasterProps) {
  return (
    <Sonner
      {...props}
      toastOptions={{
        classNames: {
          toast: cn("flex max-w-fit !items-start !shadow-lg"),
        },
      }}
      icons={{
        success: <StickerBadge type={"success"} className="mt-1" />,
        error: <StickerBadge type={"failure"} className="mt-1" />,
        warning: <StickerBadge type={"notice"} className="mt-1" />,
        info: <StickerBadge type={"information"} className="mt-1" />,
      }}
    />
  );
}

export { Toaster, sonnerToast as toast };
